import React from "react";
import {Carousel} from "react-bootstrap";
import "animate.css";

const MainSlider: React.FC = () => {
    React.useEffect(() => {
        const handleVisibilityChange = () => {
            const video = document.querySelector("video");
            if (document.visibilityState === "visible" && video?.paused) {
                video.play().catch(() => {
                    // Fallback si el navegador no permite reanudar
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    return(
        <Carousel controls={false} indicators={false} className="h-100" style={{paddingTop: "70px"}}>
            <Carousel.Item>
                <div className="carouselCaption">
                    <p><img src="/assets/logo_pomarrosa_t.png" className="logoCarousel animate__animated animate__fadeIn animate__slower" /></p>
                </div>
                <div className="video-container">
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload="none"
                        className="video-fullscreen">
                        <source src="/assets/Pomarrosa10s1080N.webm" type="video/webm" />
                    </video>
                </div>
            </Carousel.Item>
        </Carousel>
    )
}

export default MainSlider;